import { useMemo, useState } from 'react';
import moment from 'moment';
import { Accordion } from '@prosolve/common-components-ui'
import useSnackbar from '../../hooks/useSnackbar';
import EditSlimSessionModal from './EditSlimSessionModal';
import SessionBlock from './SessionBlock';

export default ({
  sessions,
  eventData = {},
  isHorizView,
  isShowEdit,
  onUpdate,
  isUpdateLoading
}) => {
  const [isShowEditModal, setIsShowEditModal] = useState()
  const [copiedSession, setCopiedSession] = useState()

  const { newMessage } = useSnackbar()

  const sessionsByDayMap = useMemo(() => {
    const sMap = {};
    sessions.forEach((session) => {
      const { date } = session;
      if (!sMap[date]) {
        sMap[date] = [];
      }
      sMap[date].push(session)
    })

    // Next we go ahead and sort each of the date arrays for effeciency
    Object.keys(sMap).forEach(key => {
      sMap[key].sort(({ startTime: startTimeA }, { startTime: startTimeB }) => moment(startTimeA, 'hh:mm:ss') - moment(startTimeB, 'hh:mm:ss'))
    });

    return sMap;
  }, [sessions]);

  const onCopy = (sessionData) => {
    setCopiedSession(sessionData)
    newMessage({ message: 'Session data copied', severity: 'success' })
  }

  const getDateHeaderBlock = (date, index) => {
    const displayDate = moment(date, 'YYYY-MM-DD').format('ddd, MM/DD/YY');
    return (
      <div>
        <div style={{ display: 'flex', alignItems: 'center', color: '#565656', fontSize: '14px' }}>
          <div>{`Day ${index + 1}`}</div>
          <div style={{ padding: '0px 5px' }}>{`-`}</div>
          <div>{`${sessionsByDayMap[date].length} Sessions`}</div>
        </div>
        <div style={{ fontWeight: 'bold', marginTop: '5px', color: '#565656', fontSize: '15px' }}>{displayDate}</div>
      </div>
    )
  }

  const getDaySessionsBlock = (date, onUpdate, isUpdateLoading) => {
    const sessionsInDay = sessionsByDayMap[date]
    return (
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        rowGap: '10px',
      }}>
        {
          sessionsInDay.map((session) =>
            <SessionBlock 
              key={session._id} 
              sessionData={session} 
              eventData={eventData}
              isShowEdit={isShowEdit} 
              onUpdate={onUpdate} 
              isUpdateLoading={isUpdateLoading} 
              onCopy={onCopy}
              copiedSession={copiedSession}
            />
          )
        }
      </div>
    )
  }

  return (
    <div style={{
      flex: 1,
      display: 'flex',
      flexDirection: isHorizView ? 'row' : 'column',
      columnGap: isHorizView ? '20px' : '0px',
      overflowX: isHorizView ? 'auto' : 'visible',
      whiteSpace: isHorizView ? 'nowrap' : 'normal'
    }}>
      {
        Object.keys(sessionsByDayMap).length > 0
          ?
          Object.keys(sessionsByDayMap)
            .sort((a, b) => moment(a, 'YYYY-MM-DD') - moment(b, 'YYYY-MM-DD'))
            .map((date, index) => {
              if (isHorizView) {
                return (
                  <div key={date} style={{ flex: '1 1 auto', paddingBottom: '20px', minWidth: '500px' }}>
                    <div style={{ padding: '20px 5px' }}>
                    {getDateHeaderBlock(date, index)}
                    </div>
                    {getDaySessionsBlock(date, onUpdate, isUpdateLoading)}
                  </div>
                )
              } else {
                return (
                  <Accordion
                    key={date}
                    title={getDateHeaderBlock(date, index)}
                    defaultOpen={true}
                    headerExpands={true}
                    style={{ padding: '20px 5px 20px 5px' }}
                    expandedStyle={{ padding: '0px 0px 10px 0px' }}
                  >
                    {getDaySessionsBlock(date, onUpdate, isUpdateLoading)}
                  </Accordion>
                )
              }
            })
          :
          <div style={{
            color: '#565656',
            fontSize: '14px',
            padding: '10px'
          }}>
            {'No sessions found'}
          </div>
      }
      {isShowEditModal &&
        <EditSlimSessionModal eventData={eventData} sessionData={isShowEditModal} onClose={() => setIsShowEditModal()} onUpdate={onUpdate} />
      }
    </div>
  )
}